/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Hotel service api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const ReserveItemStatus = {
    NotProcessed: 'NotProcessed',
    TemporaryReserved: 'TemporaryReserved',
    Finalized: 'Finalized',
    Cancelled: 'Cancelled',
    FinalizationError: 'FinalizationError',
    InProcess: 'InProcess',
    Confirmed: 'Confirmed',
    Rejected: 'Rejected',
    Waiting: 'Waiting',
    ConfirmationPending: 'ConfirmationPending',
    Expired: 'Expired',
    IgnoredReserveError: 'IgnoredReserveError'
} as const;

export type ReserveItemStatus = typeof ReserveItemStatus[keyof typeof ReserveItemStatus];



